import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {Button, Dialog, TextField} from '@betareader/design-system';
import {
  EditorState, RichUtils, convertToRaw
} from 'draft-js';
import Editor from '@draft-js-plugins/editor';
import draftToHtml from 'draftjs-to-html';
import 'draft-js/dist/Draft.css';
import moment from 'moment';

// i18n
import { withTranslation } from 'react-i18next';
// redux
import { push } from '../../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Avatar from '../../../components/avatar/avatar';
import {
  broadcastMessage
} from '../../../modules/message';

import { authUtil } from '../../../utils';

export class BroadcastMessage extends Component {
  // lifecycle methods
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      selectedReaders: []
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { readers } = nextProps;
    return {
      ...prevState,
      selectedReaders: readers.filter(reader => reader.selected)
    };
  }

  onEditorStateChange = (editorState) => {
    const plainTextMessage = editorState.getCurrentContent().getPlainText();
    this.setState({ editorState, plainTextMessage });
  };

  handleKeyCommand = (command, editorState) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onEditorStateChange(newState);
      return 'handled';
    }
    return 'not-handled';
  }

  handleSubjectChange = event => {
    this.setState({
      subject: event.target.value
    });
  }

  handleMessageTitleChange = event => {
    this.setState({
      title: event.target.value
    });
  }

  cannotSend = () => {
    const { subject, plainTextMessage } = this.state;
    return !subject || subject.length <= 0 || !plainTextMessage || plainTextMessage.length <= 0;
  }

  sendMessage = async () => {
    const { currentBook } = this.props;
    const {
      subject, title, selectedReaders, editorState
    } = this.state;
    const plainTextMessage = editorState.getCurrentContent().getPlainText();
    const rawContentState = convertToRaw(editorState.getCurrentContent());
    const htmlMessage = draftToHtml(
      rawContentState
    );

    const idToken = await authUtil.getFreshIdToken();
    this.props.broadcastMessage({
      book: currentBook._id,
      idToken,
      recipients: selectedReaders.map(reader => reader.user._id),
      title,
      subject,
      text: plainTextMessage,
      html: htmlMessage
    }, () => {
      this.setState({
        subject: '',
        title: '',
        selectedReaders: [],
        editorState: EditorState.createEmpty(),
        open: false
      });
    });
  }

  render() {
    const {t, readOnly, userProfile, sendingBroadcast} = this.props;
    const {open, subject, title, editorState, selectedReaders} = this.state;
    return <>
      <Button disabled={readOnly} onClick={() => this.setState({open: true})}>
        {t('NewMessage')} ({t('beta')})
      </Button>
      <Dialog open={Boolean(open)} title={t('NewMessage')}
        onClose={() => this.setState({open: false})}
        actions={<>
          <Button variant='secondary' onClick={() => this.setState({open: false})}>
            {t('Cancel')}
          </Button>
          <Button type='submit' form='reader-broadcast-form'
            disabled={readOnly || sendingBroadcast || this.cannotSend()}
            aria-busy={Boolean(sendingBroadcast)}>
            {t('SendMessage')}
          </Button>
        </>}>
        <form id='reader-broadcast-form' onSubmit={event => {
          event.preventDefault();
          if (!readOnly && !sendingBroadcast && !this.cannotSend()) this.sendMessage();
        }} style={{display: 'grid', gap: 'var(--br-space-3)'}}>
          <TextField id='broadcast-title' label={t('Title')}
            value={title || ''} onChange={this.handleMessageTitleChange} />
          <div aria-label={t('MessageTo')}
            style={{display: 'flex', alignItems: 'center', gap: 'var(--br-space-2)'}}>
            <span>{t('MessageTo')}:</span>
            {selectedReaders.map(reader => <Avatar key={reader._id}
              diameter={25} user={reader.user} name={reader.user?.displayName} />)}
          </div>
          <TextField id='broadcast-subject' label={t('MessageSubject')}
            value={subject || ''} onChange={this.handleSubjectChange} />
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <strong>{userProfile?.displayName}</strong>
            <span>{moment().format('ll')}</span>
          </div>
          <div role='group' aria-label={t('MessageBody')}>
            <Editor key='editor' editorState={editorState}
              onChange={this.onEditorStateChange}
              placeholder={t('MessageBody')}
              handleKeyCommand={this.handleKeyCommand} />
          </div>
        </form>
      </Dialog>
    </>;
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  userProfile: state.user.userProfile,
  sendingBroadcast: state.message.sendingBroadcast,
  readers: state.reader.readers,
  currentBook: state.book.currentBook
});

const mapDispatchToProps = dispatch => bindActionCreators({
  broadcastMessage,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(BroadcastMessage)));
